import { render, staticRenderFns } from "./shell.vue?vue&type=template&id=283f6bfc&"
import script from "./shell.vue?vue&type=script&lang=ts&"
export * from "./shell.vue?vue&type=script&lang=ts&"
import style0 from "./shell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283f6bfc')) {
      api.createRecord('283f6bfc', component.options)
    } else {
      api.reload('283f6bfc', component.options)
    }
    module.hot.accept("./shell.vue?vue&type=template&id=283f6bfc&", function () {
      api.rerender('283f6bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/view/shell.vue"
export default component.exports